import React from 'react';

/** Section generated from the "BlogPage" block of the Aurm design handoff. */
export default function BlogPage({ V }) {
  return (<>
    <div>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "112px 40px 64px" }}>{" "}
        <p style={{ display: "flex", alignItems: "center", gap: "12px", fontSize: "12px", fontWeight: "600", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.72)" }}>
          <span aria-hidden="true" style={{ width: "22px", height: "1px", background: "#DB2349", flex: "none" }}></span>Blog
        </p>{" "}
        <h1 style={{ marginTop: "26px", fontSize: "clamp(44px,6vw,80px)", lineHeight: "1", letterSpacing: "-.04em", fontWeight: "600" }}>Latest from the blog</h1>{" "}
        <p style={{ marginTop: "24px", fontSize: "20px", lineHeight: "1.55", color: "rgba(255,255,255,.78)", maxWidth: "46ch" }}>Articles, tips, guides, industry best practices, and news.</p>{" "}
      </section>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 40px" }}>{" "}
        {V.hasFeatured ? (<>{" "}
          <a className="aurm-h6" href={V.featured.href} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,420px),1fr))", borderRadius: "28px", overflow: "hidden", border: "1px solid rgba(255,255,255,.12)", background: "linear-gradient(180deg,rgba(46,30,78,.97),rgba(34,20,60,.97))", boxShadow: "inset 0 1px 0 rgba(255,255,255,.08)" }}>{" "}
            <div style={V.featured.img}></div>{" "}
            <div style={{ padding: "48px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "20px" }}>{" "}
              <p style={{ fontSize: "12px", fontWeight: "600", letterSpacing: ".2em", textTransform: "uppercase", color: "#ff8a9c" }}>Featured</p>{" "}
              <h2 style={{ fontSize: "clamp(26px,2.8vw,38px)", lineHeight: "1.15", letterSpacing: "-.03em", fontWeight: "600" }}>{V.featured.title}</h2>{" "}
              <p style={{ fontSize: "16px", lineHeight: "1.6", color: "rgba(255,255,255,.72)" }}>{V.featured.excerpt}</p>{" "}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "8px" }}>
                <img src={V.featured.avatar} alt="" style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover", background: "#2a1c46" }} />
                <span style={{ fontSize: "14px", lineHeight: "1.4" }}>
                  <span style={{ display: "block", fontWeight: "600" }}>{V.featured.by}</span>
                  <span style={{ color: "rgba(255,255,255,.6)" }}>{V.featured.at}</span>
                </span>
              </div>{" "}
            </div>{" "}
          </a>{" "}
        </>) : null}{" "}
        <div style={{ marginTop: "20px", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,340px),1fr))", gap: "20px" }}>{" "}
          {(V.restPosts || []).map((b, $index) => (
            <React.Fragment key={$index}>{" "}
            <a className="aurm-h6" href={b.href} style={{ display: "flex", flexDirection: "column", borderRadius: "24px", overflow: "hidden", border: "1px solid rgba(255,255,255,.12)", background: "linear-gradient(180deg,rgba(46,30,78,.97),rgba(34,20,60,.97))" }}>{" "}
              <div style={b.img}></div>{" "}
              <div style={{ padding: "28px", display: "flex", flexDirection: "column", gap: "14px", flex: "1" }}>{" "}
                <h3 style={{ fontSize: "22px", lineHeight: "1.25", letterSpacing: "-.02em", fontWeight: "600" }}>{b.title}</h3>{" "}
                <p style={{ fontSize: "15px", lineHeight: "1.6", color: "rgba(255,255,255,.68)" }}>{b.excerpt}</p>{" "}
                <p style={{ marginTop: "auto", paddingTop: "8px", fontSize: "13px", color: "rgba(255,255,255,.6)" }}>{b.by}{" - "}{b.at}</p>{" "}
              </div>{" "}
            </a>{" "}
            </React.Fragment>
          ))}{" "}
        </div>{" "}
      </section>
    </div>
  </>);
}
